import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Paprika } from '../../styles/theme';

interface Props {
  stepIndex: number;
  totalSteps: number;
}

/**
 * Progress dots (handoff `Dots`): active = 22px terracotta bar ·
 * done = sage dot · upcoming = warm border dot. Windowed to 7 for long recipes.
 */
export const StepProgressDots: React.FC<Props> = ({ stepIndex, totalSteps }) => {
  const dotWindow = 7;
  const startDot = Math.max(0, stepIndex - Math.floor(dotWindow / 2));
  const endDot = Math.min(totalSteps, startDot + dotWindow);
  const visibleDots = Array.from({ length: endDot - startDot }, (_, i) => startDot + i);

  return (
    <View style={styles.row}>
      {visibleDots.map((i) => {
        const active = i === stepIndex;
        const done = i < stepIndex;
        return (
          <View
            key={i}
            style={[
              styles.dot,
              done && styles.dotDone,
              active && styles.dotActive,
            ]}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    backgroundColor: Paprika.border,
  },
  dotDone: {
    backgroundColor: Paprika.success,
  },
  dotActive: {
    width: 22,
    backgroundColor: Paprika.accent,
  },
});
